import React, { Component, Fragment } from 'react';
import { Button, FormGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { webmaster } from '../../services/ApiService';
import { startSetProfile } from '../../actions/webmaster';
import SMSNotificationsModal from '../../modals/SMSNotificationsModal/SMSNotificationsModal';
import { ThemedFMessage } from '../../hoc/IntlComponents';

class EditNotificationsSMS extends Component {
  state = {
    modalOpen: false,
    sessionId: 0,
    validTill: 0,
    isLoading: false,
    error: null,
    status: null,
    transport: 'sms',
  };

  toggleModal = () => {
    this.setState(prevState => ({
      modalOpen: !prevState.modalOpen,
    }));
  };

  getTimeDiff = ts => {
    const validDate = new Date(ts).getTime();

    return validDate;
  };

  sendSMSConfirm = () => {
    const { validTill, sessionId } = this.state;
    const { sms_payout } = this.props;
    const value = sms_payout ? 0 : 1;

    if (this.getTimeDiff(validTill) && sessionId) {
      this.toggleModal();
    } else {
      this.setState({
        isLoading: true,
      });

      webmaster
        .confirnSMSPayout({
          value,
        })
        .then(() => {})
        .catch(err => {
          if (err && err.response) {
            const { response } = err.response.data;

            if (response && err.response.status === 401) {
              const { verification } = response;
              const { sessionId, validTill, transport } = verification;

              this.setState(
                () => ({
                  isLoading: false,
                  transport,
                  sessionId,
                  validTill,
                  status: err.response.status,
                  error: null,
                }),
                () => {
                  this.toggleModal();
                },
              );
            }
          }
        });
    }
  };

  onSubmit = (e, verification_code) => {
    const { sessionId } = this.state;
    const { startSetProfile, openAlert, sms_payout } = this.props;
    const value = sms_payout ? 0 : 1;
    webmaster
      .confirnSMSPayout({
        verification_session_id: sessionId,
        verification_code,
        value,
      })
      .then(() =>
        startSetProfile().then(() => {
          this.setState(() => ({
            modalOpen: false,
            error: null,
            status: null,
            sessionId: 0,
            validTill: 0,
          }));
        }),
      )
      .then(() => {
        openAlert(
          <FormattedMessage id="notifications.update.success" defaultMessage="Update successful" />,
        );
      })
      .catch(err => {
        const { response } = err;
        if (response) {
          const { data } = response;

          if (data && data.error) {
            const { message, code } = data.error;
            if (code === 403) {
              this.setState(() => ({
                sessionId: 0,
                validTill: 0,
                error: message.message,
                status: code,
              }));
            } else {
              if (message) {
                this.setState(() => ({
                  error: message.message,
                }));
              }
            }
            if (message) {
              this.setState(() => ({
                error: message.message,
              }));
            }
          }
        }
      });
  };

  render() {
    const { modalOpen, sessionId, validTill, isLoading, error, status, transport } = this.state;
    const { sms_payout, theme } = this.props;
    const timeDiff = this.getTimeDiff(validTill);

    return (
      <Fragment>
        <FormGroup>
          <Button
            color={theme === 4 ? 'primary' : 'info'}
            onClick={this.sendSMSConfirm}
            disabled={isLoading}
          >
            {sms_payout ? (
              <ThemedFMessage id="edit_notifications_sms_disable" />
            ) : (
              <ThemedFMessage id="edit_notifications_sms" />
            )}
          </Button>
        </FormGroup>
        <SMSNotificationsModal
          transport={transport}
          sessionId={sessionId}
          validTill={timeDiff}
          isOpen={modalOpen}
          toggleModal={this.toggleModal}
          onSubmit={this.onSubmit}
          error={error}
          status={status}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ webmaster }) => ({
  sms_payout: webmaster.profile.sms_payout,
});

const mapDispatchToProps = dispatch => ({
  startSetProfile: () => dispatch(startSetProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditNotificationsSMS);
